import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { useTheme } from '@/lib/theme';
import '@/i18n';
import './index.css';
import { AuthProvider } from '@/auth/AuthProvider';
import { TooltipProvider } from '@/components/ui/Tooltip';
import { createQueryClient } from '@/lib/queryClient';
import { installErrorReporting } from '@/lib/errorReporting';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { App } from './App';

installErrorReporting();

/** Toasts in the look's light or dark base and typeface. */
function ThemedToaster() {
  const { resolved } = useTheme();
  return <Toaster position="bottom-right" richColors closeButton theme={resolved} toastOptions={{ className: 'tp-toast' }} />;
}
const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <BrowserRouter>
          <AuthProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
        <ThemedToaster />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
